// extracted by mini-css-extract-plugin
export var isPrintedCell = "_ww-1";
export var printerIcon = "_ww-0";